/* 🤖 this file was generated by svg-to-ts */
export var spxIconMaintenance = {
    name: 'maintenance',
    data: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\" fill=\"#262626\"><path d=\"M63.464,13.639a1.5,1.5,0,0,0-2.515-.689l-9.295,9.295-8.485-1.414-1.414-8.485L51.05,3.051a1.5,1.5,0,0,0-.707-2.52A17.913,17.913,0,0,0,29.014,23.673L2.34,50.346A8,8,0,0,0,13.653,61.659L40.3,35.007a17.94,17.94,0,0,0,23.16-21.369ZM8,59a3,3,0,1,1,3-3A3,3,0,0,1,8,59Z\" transform=\"translate(0.003 -0.001)\"/></svg>"
};
